<template>
  <v-app>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row justify="center" align="center">
          <v-col cols="12" sm="8" md="4">
            <v-alert :value="getLoginAlert.show" dense :type="getLoginAlert.type" :icon="getLoginAlert.icon" dismissible @input="closeLoginAlert()">{{ getLoginAlert.message }}</v-alert>
            <v-alert v-if="getShowVerificationMessage" color="green" type="info">The verification email has been sent. Please verify your email address.</v-alert>
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-alert :value="alert.show" dense outlined :type="alert.type" :icon="alert.icon">{{ alert.message }} <a v-if="alert.url" @click.stop.prevent="resendVerificationEmail()">Resend the email</a></v-alert>              
                <v-form ref="loginForm">
                  <v-row justify="center" align="center" dense>
                    <v-col cols="12">
                      <v-text-field id="email" label="Email" name="email" prepend-icon="person" type="text" v-model="email" autocomplete="username" :rules="[...getRlDialogRules.required, ...getRlDialogRules.email, ...getRlDialogRules.stringMax100]" maxlength="100" autofocus />
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center" dense>
                    <v-col cols="12">                  
                      <v-text-field @keyup.enter="login()" id="password" label="Password" name="password" prepend-icon="lock" type="password" v-model="password" autocomplete="current-password" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax30]" maxlength="30" />
                    </v-col>
                  </v-row>
                  <v-row justify="start" align="center" dense>
                    <v-col cols="auto">
                      <a class="reset" @click.prevent="forgot()">Forgot Password</a>
                    </v-col>
                    <v-spacer />
                    <v-col cols="auto">
                      <v-checkbox id="remember" label="Remember Me" name="remember" @change="updateRemember" v-model="remember" />
                    </v-col>
                  </v-row>                   
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-row justify="end" align="center" dense>
                  <v-col cols="auto">
                    <v-btn color="primary" @click.prevent="signup()">Sign up</v-btn>
                  </v-col>
                  <v-spacer />
                  <v-col cols="auto">
                    <v-btn color="primary" @click.prevent="login()">Log in<v-icon>navigate_next</v-icon></v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-overlay :value="dialogLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'Login',
  data() {
    return {
      email: null,
      password: null,
      remember: false,
      alert: {show: false, type: null, icon: null, message: null},
      dialogLoading: false
    }
  },
  mounted(){
    this.setRemember(this.remember)
  },
  methods: {
    async login() {
      try {
        if(this.$refs.loginForm.validate()) {
          this.dialogLoading = true
        
          await axios.get('sanctum/csrf-cookie')

          if (this.remember) {
            await axios.post('api/v1/auth/login', {email: this.email, password: this.password, remember: true})
          } else {
            await axios.post('api/v1/auth/login', {email: this.email, password: this.password})
          }
         
          const response = await axios.get('api/v1/user')

          this.setUser(response.data.data)
          await this.$router.replace('/', () => {})

          this.setLoginAlert({show: false})
          this.dialogLoading = false
          this.setShowVerificationMessage(false)
        }
      } catch (error) {
        this.dialogLoading = false
        if (error.response.data?.errors?.email) {
          this.alert = { show: true, type: "error", icon: "error", message: error.response.data.errors.email[0] }
        } else {
          this.alert = { show: true, type: "error", icon: "error", message: error.response.data.message, url: error.response.data.url }
        }
      }
    },
    updateRemember() {     
      this.setRemember(this.remember)
    },
    signup() {
      this.$router.push('/signup')
    },
    forgot() {
      this.$router.push('/forgot-password')
    },
    closeLoginAlert() {
      this.setLoginAlert({show: false})
    },
    async resendVerificationEmail() {
      try {
        this.dialogLoading = true

        await axios.get('sanctum/csrf-cookie')
        const response = await axios.post(this.alert.url)

        this.dialogLoading = false

        if (response.status === 200) {
          this.alert = { show: false }
          this.setLoginAlert({ show: true, type: "success", icon: "check_circle", message: response.data.message })
        }
      } catch (error) {
        this.dialogLoading = false
        this.alert = { show: true, type: "error", icon: "error", message: error.response.data.message, url: error.response.data.url }
      }
    },
    ...mapActions([
      'setRemember',
      'setLoginAlert',
      'setUser',
      'setShowVerificationMessage',
    ])
  },
  computed: {
    ...mapGetters([      
      'getRlDialogRules',
      'getLoginAlert',
      'getShowVerificationMessage'
		])
  }
}
</script>

<style scoped>
  .reset {
    color: grey;
    font-size: 16px;
  } 
</style>


